import { Period } from '../contexts/DataProvider'
interface MyEndpointParams {
  startTime?: Date
  endTime?: Date
  studieId?: string
  period?: string
}
export const countDuplicate = (array) => {
  return array.reduce((prev, cur) => {
    prev[cur] = (prev[cur] || 0) + 1
    return prev
  }, {})
}
const PERIODS: Record<Period, string> = {
  Day: 'hour',
  Week: 'day',
  Month: 'day',
  Year: 'month',
}
export const getPeriod = (period: Period): string => PERIODS[period]

export const callGetStudie = (params?: MyEndpointParams) => {
  const queryString = new URLSearchParams()

  for (const key in params) {
    if (!params[key as keyof MyEndpointParams]) continue
    queryString.append(key, (params as any)[key as keyof MyEndpointParams])
  }

  return queryString.toString()
}

export const scrollToTop = (id) => {
  if (document.querySelector(id)) {
    document.querySelector(id).scrollTo({
      top: 0,
    })
  }
}
